var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "borrowMoneylist" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
        on: { Refresh: _vm.onHandleRefresh, search: _vm.onSearch },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.onHandleAdd },
                  },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "品牌名", prop: "brand", align: "center" },
              }),
              _c("el-table-column", {
                attrs: { label: "推荐语", prop: "recommend", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "最高可借额度",
                  prop: "loan_amount",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "最高年化利率",
                  prop: "loan_rate",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.loan_rate) + "% ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "排序", prop: "sort_field", align: "center" },
              }),
              _c("el-table-column", {
                attrs: { label: "位置", prop: "type", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  align: "center",
                  label: "状态",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("启用"),
                            ])
                          : _vm._e(),
                        scope.row.status === -1
                          ? _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v("停用"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        scope.row.status != 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.gopath(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看数据")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: _vm.title,
                visible: _vm.centerDialogVisible,
                width: "70%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "contents",
                  staticStyle: { "padding-top": "20px" },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "160px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌名", prop: "brand" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入品牌名",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.brand,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "brand", $$v)
                                  },
                                  expression: "ruleForm.brand",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "最高可借额度", prop: "loan_amount" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入最高可借额度",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.loan_amount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "loan_amount", $$v)
                                  },
                                  expression: "ruleForm.loan_amount",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "最高年化利率", prop: "loan_rate" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入最高年化利率",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.loan_rate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "loan_rate", $$v)
                                    },
                                    expression: "ruleForm.loan_rate",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型", prop: "type" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请选择类型" },
                              model: {
                                value: _vm.ruleForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "type", $$v)
                                },
                                expression: "ruleForm.type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "banner", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "列表", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "推荐语", prop: "recommend" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入推荐语",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.recommend,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "recommend", $$v)
                                  },
                                  expression: "ruleForm.recommend",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "上传 logo", prop: "logo" } },
                        [
                          _c(
                            "el-upload",
                            {
                              class: { hide: _vm.logo.length == 1 },
                              attrs: {
                                action: "#",
                                "file-list": _vm.logo,
                                "list-type": "picture-card",
                                "http-request": (file) => {
                                  return _vm.uploadFile(file, "logo")
                                },
                                "before-remove": (file, fileList) => {
                                  return _vm.deleteFile(file, fileList, "logo")
                                },
                                limit: 1,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "trigger" },
                                slot: "trigger",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序", prop: "sort_field" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入排序",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.sort_field,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "sort_field", $$v)
                                  },
                                  expression: "ruleForm.sort_field",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "跳转类型",
                            prop: "external_link_type",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请选择跳转类型" },
                              model: {
                                value: _vm.ruleForm.external_link_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "external_link_type",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.external_link_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "小程序", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "h5", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跳转链接", prop: "external_link" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入跳转链接",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.external_link,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "external_link", $$v)
                                  },
                                  expression: "ruleForm.external_link",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.ruleForm.external_link_type == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "appid", prop: "app_id" } },
                            [
                              _c(
                                "div",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入appid",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.ruleForm.app_id,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "app_id", $$v)
                                      },
                                      expression: "ruleForm.app_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "status", $$v)
                                },
                                expression: "ruleForm.status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("启用"),
                              ]),
                              _c("el-radio", { attrs: { label: -1 } }, [
                                _vm._v("停用"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.btndisabled },
                      on: { click: _vm.addCategories },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }